import { createRouter, createWebHashHistory } from 'vue-router'
import LoginView from '../views/LoginView.vue'
import HomeView from '../views/HomeView.vue'
import VentasView from '../views/Reportes/VentasView.vue'
import VentasPlacaView from '../views/Reportes/VentasPlacaView.vue'
import VentasHoraView from '../views/Reportes/VentasPorHoraView.vue'
import VentasCanastillaView from '../views/Reportes/VentasCanastillaView.vue'
import FElectronicaView from '../views/Reportes/FElectronicaView.vue'
import NClectronicaView from '../views/Reportes/FENotasCreditosView.vue'
import VentasDespachosView from '../views/Clientes/VentasDespachosView.vue'
import VentasConciliadasView from '../views/Reportes/VentasConciliadasView.vue'
import ClientesView from '../views/Clientes/ClientesView.vue'
import RecargasView from '../views/Clientes/RecargasView.vue'
import ExtractoCuentasView from '../views/Clientes/ExtractoCuentasView.vue'
import FlotasView from '../views/Vehiculos/FlotasView.vue'
import VehiculosView from '../views/Vehiculos/VehiculosView.vue'
import ConversionesView from '../views/Vehiculos/ConversionesView.vue'
import CorteDiarioView from '../views/Reportes/CorteDiarioView.vue'
import TurnosView from '../views/Reportes/TurnosView.vue'
import FacturadorView from '../views/Facturador/FacturadorView.vue'
import FacturadorPOSView from '../views/Facturador/FacturadorPOSView.vue'
import DescuentoView from '../views/Descuentos/DescuentoView.vue'
import RecaudoView from '../views/Financieras/RecaudoView.vue'
import EntidadesAcuerdosView from '../views/Financieras/EntidadesAcuerdosView.vue'
import ReporteRecaudosView from '../views/Financieras/ReporteRecaudosView.vue'
import GestionUsuariosView from '../views/Personas/GestionUsuariosView.vue'
import ImportadorView from '@/views/Vehiculos/ImportadorView.vue' 
import ParametrosView from '../views/Parametros/ParametrosView.vue'  
import ClientePrecioView from '@/views/Clientes/ClientePrecioView.vue'


const routes = [
  {
    path: '/',
    name: 'login',
    component: LoginView,
  },
  {
    path: '/home',
    name: 'home',
    component: HomeView,
  },
  {
    path: '/reportes/ventas',
    name: 'reportes-ventas',
    component: VentasView,
  },
  {
    path: '/reportes/ventas_placa',
    name: 'reportes-ventas-placa',
    component: VentasPlacaView,
  },
  {
    path: '/reportes/ventas_horas',
    name: 'reportes-ventas-horas',
    component: VentasHoraView,
  },
  {
    path: '/reportes/ventas_documento',
    name: 'reportes-ventas-documento',
    component: VentasCanastillaView,
  },
  {
    path: '/reportes/felectronica',
    name: 'reportes-felectronica',
    component: FElectronicaView,
  },
  {
    path: '/reportes/ncelectronica',
    name: 'reportes-ncelectronica',
    component: NClectronicaView,
  },
  {
    path: '/reportes/conciliaciones',
    name: 'reportes-conciliaciones',
    component: VentasConciliadasView,
  },
  {
    path: '/clientes',
    name: 'clientes',
    component: ClientesView,
  },
  {
    path: '/recargas',
    name: 'recargas',
    component: RecargasView,
  },
  {
    path: '/extracto',
    name: 'extracto',
    component: ExtractoCuentasView,
  },
  {
    path: '/clientes/despachos',
    name: 'despachos',
    component: VentasDespachosView,
  },
  {
    path: '/flotas',
    name: 'flotas',
    component: FlotasView,
  },
  {
    path: '/reportes/corte',
    name: 'corte',
    component: CorteDiarioView,
  },
  {
    path: '/reportes/turnos',
    name: 'turnos',
    component: TurnosView,
  },
  {
    path: '/facturador/facturador/:uuid?',
    name: 'facturador',
    component: FacturadorView,
  },
    {
    path: '/facturador/facturadorPOS',
    name: 'facturadorPOS',
    component: FacturadorPOSView,
  },
  {
    path: '/descuentos',
    name: 'descuentos',
    component: DescuentoView,
  },
  {
    path: '/vehiculos',
    name: 'vehiculos',
    component: VehiculosView,
  },
  {
    path: '/importador',
    name: 'importador',
    component: ImportadorView,
  },
  {
    path: '/conversiones',
    name: 'conversiones',
    component: ConversionesView,
  },
  {
    path: '/recaudos',
    name: 'recaudos',
    component: RecaudoView,
  },
  {
    path: '/entidades-acuerdos',
    name: 'entidades-acuerdos',
    component: EntidadesAcuerdosView,
  },
  {
    path: '/reporte-recaudos',
    name: 'reporte-recaudos',
    component: ReporteRecaudosView,
  },
  {
    path: '/usuarios',
    name: 'usuarios',
    component: GestionUsuariosView,
  },
  {
    path: '/parametros-empresa',
    name: 'parametros-empresa',
    component: ParametrosView,
  },
  {
    path: '/cliente-precio',
    name : 'cliente-precio',
    component: ClientePrecioView,
  }
]



const router = createRouter({
  history: createWebHashHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  if (to.name === "home") { // Verifica si la ruta solicitada es "home"
    const user = JSON.parse(sessionStorage.getItem("kubber.persona"));
    const perfilUsuario = parseInt(atob(user.perfil_id));

    // Define el componente para el perfil de usuario
    let componenteHome = HomeView; // Componente predeterminado para perfiles 1, 2 y 5

    switch (perfilUsuario) {
      case 8:
        componenteHome = FacturadorPOSView; // Componente para perfil 8
        break;
      case 5:
        componenteHome = VehiculosView; // Componente para perfil 6
        break;
      case 6:
        componenteHome = RecaudoView; // Componente para perfil 6
        break;
      // Agrega más casos según tus necesidades
    }

    // Actualiza el componente del objeto "to" para cargar el componente correcto
    to.matched[0].components.default = componenteHome;
  }

  next();
});



export default router
